<template>
  <div>
    <div style="width:30px;height:30px;position:fixed;top:0;right:0;" @click="escPrint"></div>
    <button class="btn btn-info no-print" @click="getAllCurrentViewData">load</button>
    <button class="btn btn-info no-print" @click="drawTransAndMVPoles">draw</button>
    <button class="btn btn-info no-print" @click="makePrintable">print</button>
   
    <section class="sheet padding-10mm">
      <div class="row">
        <div id="mapid" class="col-12"></div>
      </div>
     
    </section>
    
  </div>
</template>


<script>
import { ApiTls } from "../../src/app/tools/ApiTls";
import { MapTls } from "../../src/app/tools/MapTls";
import { BoundTls } from "../app/tools/BoundTls";
import { PrintTls } from "../app/tools/PrintTls";


export default {
  components: {  },
  name: "Feeder",
  data() {
    return {
      mymap: null,
      printable: false,
      feederId:0,
      feederData:{}
    };
  },
  mounted() {
    // if (this.mymap == null)
    this.mymap = MapTls.initMap("mapid");
    BoundTls.resetMinMaxBound();
    ApiTls.startTmp(this.mymap, this.$route.params.feederId);
  },
  methods: {
    getAllCurrentViewData() {
      ApiTls.getAllCurrentViewData(this.mymap);
    },
    drawTransAndMVPoles() {
      ApiTls.drawTransAndMVPoles(this.mymap);
    },
    makePrintable() {
      PrintTls.makePrintable();
    },
    escPrint(){
      PrintTls.escPrintable();
    }
  },
};
</script>



<style scoped>
.leaflet-container {
  background: #fff;
  outline: 0;
}

.leaflet-popup-tip-container {
  display: none;
}

#mapid {
  width: 100%;
  height: 70vh;
}
</style>
